import React, { FC } from 'react';


import { GRADIENTS, Gradient } from '../../config/designSystem/Colors';
import { GradientView } from '../Gradients/GradientView';
import { SPACING } from '../../config/designSystem/Spacing';
import { View } from 'react-native';

interface TopAndBottomViewProp {
    topChildren: React.ReactElement;
    bottomChildren: React.ReactElement;
  }

const TopAndBottomView: FC<TopAndBottomViewProp> = ({topChildren, bottomChildren}: TopAndBottomViewProp) => {

  return (
    <View style={{flex:1}}>
      <View style={{rowGap: SPACING['sp-12']}} >
        {topChildren}
      </View>
      <View style={{flex:1,justifyContent:'flex-end'}}>
        <GradientView gradient={GRADIENTS.brand['primary-light'] as Gradient} style={{marginBottom: SPACING['sp-8']}}>
          <View style={{height:1, width:'100%' }}/>
        </GradientView>

        <View style={{rowGap: SPACING['sp-12']}} >
          {bottomChildren}
        </View>
      </View>


    </View>  );
};



export default TopAndBottomView;